import { DataItemFormatter } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { getRouteToCallback } from '../../../../../utils/formattersUtils';
import styles from './CompanyNameDescriptionRenderer.module.scss';

const cx = classNames.bind(styles);

const CompanyNameDescriptionRenderer: DataItemFormatter<string, ReactElement> = ({
  value: displayName,
  item,
  configuration,
}) => {
  const routeToCallback = getRouteToCallback(configuration, item);

  return (
    <Link to={routeToCallback} key={displayName} className={cx('body')} data-testid="company-name-description-renderer">
      <h2 className={cx('title')}>{displayName}</h2>
      {item.businessDescription && <span dangerouslySetInnerHTML={{ __html: item.businessDescription }} />}
    </Link>
  );
};

export default CompanyNameDescriptionRenderer;
